export const userSettingsAction = (userData: any) => {

    return {
        type: 'USER_SETTINGS',
        payload: userData
    };
}


export const userLoginAction = (userData: any) => {
    return {
        type: 'USER_LOGIN',
        payload: userData
    };
}

export const userLogoutAction = (userData: any) => {
    return {
        type: 'USER_LOGOUT',
        payload: userData
    };
}

export const appContextSetAction = (appContextData: any) => {
    return {
        type: 'APP_CONTEXT_SET',
        payload: appContextData
    };
}

export const addNotification = (notification: any) => {
    return {
        type: 'ADD_NOTIFICATION',
        payload: notification
    };
}

export const removeNotification = (notification: any) => {
    return {
        type: 'REMOVE_NOTIFICATION',
        payload: notification
    };
}